import { ServiceHandler } from '../../../utils/api.utils';
import type { ActionExecuteRequest, ActionExecuteResponse } from '../types';

export const executeAction = ServiceHandler<ActionExecuteRequest, ActionExecuteResponse>({
  url: '/api/chat-agent/v1/actions/execute',
  method: 'POST',
});
